import Vue from 'vue'
import Router from 'vue-router'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import routeDefinitions from './routes.json'

Vue.use(Router)

// Import and register views

const views = {}
export let routes = []

const requireView = require.context('./views', true, /[A-Z]\w+\.(vue|js)$/)

requireView.keys().forEach(fileName => {
  const componentName = fileName
    .split('/')
    .map(part => {
      return upperFirst(camelCase(part.replace(/\.\w+$/, '')))
    })
    .join('')
  views[componentName] = requireView(fileName).default || requireView(fileName)
})

// Register routes

const addRoutes = routesArray => {
  routesArray.forEach(group => {
    group.routes.forEach(route => {
      routes.push({
        path: route.path,
        name: route.component.toLowerCase(),
        component: views[route.component]
      })
    })
  })
}

addRoutes(routeDefinitions)

// Set up router

export default new Router({
  routes
})
